var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBnb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256 128C256 198.694 198.694 256 128 256C57.3056 256 0 198.694 0 128C0 57.3056 57.3056 0 128 0C198.694 0 256 57.3056 256 128ZM128 71.8341L90.7121 111.565L90.7128 111.562L69.0176 88.4457L128 25.6L187.002 88.4645L165.306 111.581L128 71.8341ZM53.6968 104.767L32 127.887L53.6952 151L75.392 127.884L53.6968 104.767ZM128 183.941L90.7121 144.214L68.9869 167.297L69.0176 167.331L128 230.176L187.002 167.311L187.012 167.3L165.304 144.195L128 183.941ZM202.305 104.78L180.608 127.898L202.304 151.014L224 127.896L202.305 104.78ZM150.013 127.876H150.006L150.026 127.887L150.015 127.9L128 151.357L106.003 127.917L105.972 127.884L106.003 127.852L128 104.419L150.013 127.876Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/bnb.23707d25.svg";
export { ForwardRef as ReactComponent };